<template>
  <div id="page-user-view">
    <div id="user-data" v-if="state">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card title="Account" class="mb-base">
                <div class="vx-row">
                  <div class="vx-col" id="avatar-col">
                    <div class="img-container mb-4">
                      <img :src="profile.$href('avatar')" class="rounded w-full"/>
                    </div>
                  </div>

                  <div class="vx-col flex account-info-col-1">
                    <table>
                      <tr>
                        <td class="font-semibold">Username</td>
                        <td class="pl-4">{{ state.login }}</td>
                      </tr>

                      <tr>
                        <td class="font-semibold">Email</td>
                        <td class="pl-4">{{ state.email }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Firstname</td>
                        <td class="pl-4">{{ state.firstname }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Lastname</td>
                        <td class="pl-4">{{ state.lastname }}</td>
                      </tr>
                      <tr v-if="isCaseManagerTeamOn">
                        <td class="font-semibold">{{ hqTeamLabel }}</td>
                        <td v-if="!editTeam">
                          <div class="vx-col flex-shrink pl-4">
                            {{ state.hqTeamName || $t('profile.selectOption') }}
                            <vs-icon icon="edit" class="action-button ml-2 cursor-pointer" size="small" color="primary"
                                     @click="onEditTeam"></vs-icon>
                          </div>
                        </td>
                        <td v-else>
                          <div class="vx-row">
                            <div class="vx-col flex w-3/4 pr-0">
                              <vs-select autocomplete
                                         v-model="selectedHqTeam">
                                <vs-select-item :value="null" :text="$t('profile.selectOption')"></vs-select-item>
                                <template v-if="teamGroups.length === 1">
                                  <vs-select-item v-for="team in teamGroups[0].teams" :key="team.id" :value="team.id"
                                                  :text="team.name"></vs-select-item>
                                </template>
                                <template v-else>
                                  <div v-for="group in teamGroups" :key="group.groupName">
                                    <vs-select-group :title="group.groupName">
                                      <vs-select-item v-for="team in group.teams" :key="team.id" :value="team.id"
                                                      :text="team.name"></vs-select-item>
                                    </vs-select-group>
                                  </div>
                                </template>
                              </vs-select>
                            </div>
                            <div class="vx-col flex w-1/4 pl-0">
                              <vs-icon icon="done" class="action-button ml-2 pt-2 cursor-pointer" size="small"
                                       color="primary" @click="onSaveTeam"></vs-icon>
                              <vs-icon icon="close" class="action-button ml-2 pt-2 cursor-pointer" size="small"
                                       color="warning" @click="onResetTeam"></vs-icon>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card title="Email Settings" class="mb-base">
                <div class="vx-row">
                  <div class="vx-col flex account-info-col-1">
                    <table>
                      <tr>
                        <td class="font-semibold">Referral Acceptance</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedNotificationAcceptance"
                                     @click="onEditNotificationAcceptance"></vs-switch>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Copy of Referral Invitation</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedNotificationCopy" @click="onEditNotificationCopy"></vs-switch>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Copy of Referral Reminders at 7 & 14 Days</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedNotificationRemind" @click="onEditNotificationRemind"></vs-switch>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Referral Expiration</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedNotificationExpire" @click="onEditNotificationExpire"></vs-switch>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Copy of Referral Invitation Sent on My Behalf</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedNotificationOnBehalfCopy" @click="onEditNotificationOnBehalfCopy"></vs-switch>
                        </td>
                      </tr>
                      <tr v-if="hasPhq9Permission">
                        <td class="font-semibold">PHQ9 Self-Harm Notification</td>
                        <td class="pl-4">
                          <vs-switch color="success" v-model="selectedPHQ9SelfHarmNotification" @click="onEditNotificationPHQ9SelfHarm"></vs-switch>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Two-step verification</td>
                        <td class="pl-4" v-if="enableMFA">
                          <vs-button  color="primary" @click.native="onEnableMFA">Enable</vs-button>
                        </td>
                        <td v-else>
                          <p><i>Two-verification is enabled</i></p>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <vs-popup title="Two-step verification" :active.sync="showPopup" @closed="onPopUpClose">
              <div class="pt-2" v-if = "enableMFA">
                <security-mfa-setup :cognito-user="cognitoUser" @updated="onUpdate" @error="onCancel">
                  <template v-slot:footer="{ submit, valid }">
                    <div class="vx-row justify-center">
                      <div class="vx-col">
                        <vs-button class="mr-1" @click="submit" :disabled="!valid">Save</vs-button>
                      </div>
                    </div>
                  </template>
                </security-mfa-setup>
              </div>
          </vs-popup>

          <div class="vx-row">
            <div class="vx-col w-full">
              <profile-default-message :profile-resource="profile" @updated="onRefresh"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {Resource} from 'hal-client';
import ProfileDefaultMessage from '@/views/app/profile/profile-default-message';
import SecurityMfaSetup from '@/views/app/security/edit/security-mfa-setup';
import { Auth } from 'aws-amplify';
export default {
  components: {ProfileDefaultMessage, SecurityMfaSetup},
  props: {
    profileResource: {
      type: Resource,
      required: true
    }
  },
  data () {
    return {
      profile: this.profileResource,
      state: this.profileResource.state(),
      hqTeamLabel: null,
      selectedHqTeam: this.profileResource.hqTeamId,
      editTeam: false,
      teamGroups: null,
      isCaseManagerTeamOn: false,
      selectedNotificationAcceptance: this.profileResource.notificationReferralAcceptance,
      selectedNotificationCopy: this.profileResource.notificationReferralInvitationCopy,
      selectedNotificationRemind: this.profileResource.notificationReferralReminder,
      selectedNotificationExpire: this.profileResource.notificationReferralExpiration,
      selectedNotificationOnBehalfCopy: this.profileResource.notificationReferralInvitationOnBehalfCopy,
      selectedPHQ9SelfHarmNotification: this.profileResource.notificationPHQ9SelfHarm,
      updateKey: 0,
      enableMFA: false,
      cognitoUser: null,
      errorMessage: false,
      showPopup: false,
      hasPhq9Permission: null
    };
  },
  mounted () {
    if (this.profileResource.$hasLink('hq-team-label')) {
      this.profileResource.$request().$get('hq-team-label').then(res => {
        this.isCaseManagerTeamOn = res.state().enabled;
        this.hqTeamLabel = res.state().label;
        if (!this.hqTeamLabel) {
          this.hqTeamLabel = this.$t('profile.team');
        }
      });
    }
    if (this.profileResource.$hasLink('hq-teams')) {
      this.profileResource.$request().$get('hq-teams').then(res => {
        this.teamGroups = res;
      });
    }
    if (this.profileResource.$hasLink('metadata-flag')) {
      this.updatePHQ9Permission();
    }
    try {
      Auth.currentAuthenticatedUser().then(user => {
        this.cognitoUser = user;
        if (user.preferredMFA === 'NOMFA') {
          this.enableMFA = true;
        }
      });
    } catch (err) {
      this.$log.error(err);
    }
  },
  methods: {
    updatePHQ9Permission () {
      const metadataLink = this.profileResource.$link('metadata-flag').href;
      const url = new URL(metadataLink);
      const params = new URLSearchParams(url.search);
      this.hasPhq9Permission = params.get('hasPhq9Permission') === 'true';
    },
    onEditTeam () {
      this.editTeam = !this.editTeam;
    },
    onSaveTeam () {
      if (this.selectedHqTeam === this.state.hqTeamId) {
        this.editTeam = false;
        return;
      }
      if (this.selectedHqTeam) {
        this.state.hqTeamId = this.selectedHqTeam;
        this.state.hqTeamName = this.teamGroups.flatMap(g => g.teams).find(t => t.id === this.selectedHqTeam).name;
      } else {
        this.state.hqTeamId = null;
        this.state.hqTeamName = null;
      }
      this.profileResource.$request().$post('edit-profile', null, this.state).then(res => {
        this.state = res.state();
        this.editTeam = false;
      });
    },
    onResetTeam () {
      this.selectedHqTeam = this.state.hqTeamId;
      const team = this.teamGroups.flatMap(g => g.teams).find(t => t.id === this.state.hqTeamId);
      this.state.hqTeamName = team ? team.name : null;
      this.editTeam = false;
    },
    onEditNotificationAcceptance () {
      this.state.notificationReferralAcceptance = !this.selectedNotificationAcceptance;
      this.updateProfile();
    },
    onEditNotificationCopy () {
      this.state.notificationReferralInvitationCopy = !this.selectedNotificationCopy;
      this.updateProfile();
    },
    onEditNotificationRemind () {
      this.state.notificationReferralReminder = !this.selectedNotificationRemind;
      this.updateProfile();
    },
    onEditNotificationExpire () {
      this.state.notificationReferralExpiration = !this.selectedNotificationExpire;
      this.updateProfile();
    },
    onRefresh () {
      this.profileResource.$request().$getSelf().then(res => {
        this.profile = res;
        this.state = res.state();
      });
    },
    onEditNotificationOnBehalfCopy () {
      this.state.notificationReferralInvitationOnBehalfCopy = !this.selectedNotificationOnBehalfCopy;
      this.updateProfile();
    },
    onEditNotificationPHQ9SelfHarm () {
      this.state.notificationPHQ9SelfHarm = !this.selectedPHQ9SelfHarmNotification;
      this.updateProfile();
    },
    updateProfile () {
      this.profileResource.$request().$post('edit-profile', null, this.state).then(res => {
        this.profile = res;
        this.state = res.state();
        if (this.profileResource.$hasLink('metadata-flag')) {
          this.updatePHQ9Permission();
        }
      });
    },
    onEnableMFA () {
      try {
        Auth.currentAuthenticatedUser().then(user => {
          this.cognitoUser = user;
          this.enableMFA = true;
          this.showPopup = true;
        });
      } catch (err) {
        this.$log.error(err);
      }
    },
    onCancel () {
      this.$router.push({
        name: 'page-login'
      });
    },
    onUpdate (isConfigured) {
      if (!isConfigured) {
        this.errorMessage = true;
        this.showPopup = false;
        return;
      }
      Auth.signOut();
      this.$router.push({
        name: 'page-login'
      });
    },
    onPopUpClose () {
      this.showPopup  = false;
    },
    notifyUpdated: _.debounce(function () {
      // eslint-disable-next-line
      this.$vs.notify({
        title: 'Profile updated',
        text: 'Your changes to your profile have been saved.',
        iconPack: 'feather',
        icon: 'icon-check-circle',
        color: 'success'
      });
    }, 2000)
  }
};

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  .account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

.action-button {
  vertical-align: bottom;
}
</style>
